import { intlCurrencyNumber } from '@/libs/util'
const FieldsDef = {
  columns: [
    {
      type: 'index',
      width: 30,
      align: 'center'
    },
    {
      key: 'title',
      title: 'Description',
      align: 'left',
      minWidth: 150
    },
    {
      key: 'quantity',
      title: 'Qty',
      align: 'right',
      minWidth: 60,
      render: (h, params) => {
        return h('span', params.row.quantity)
      }
    },
    {
      key: 'unit_price',
      title: 'Price',
      align: 'right',
      minWidth: 90,
      render: (h, params) => {
        return h('span', intlCurrencyNumber(params.row.currency, params.row.unit_price, 2, 2))
      }
    },
    {
      key: 'sub_total',
      title: 'Amount',
      align: 'right',
      minWidth: 90,
      render: (h, params) => {
        let amount = params.row.line_total
        return h('span', intlCurrencyNumber(params.row.currency, amount, 2, 2))
      }
    }
  ]
}

export default FieldsDef
